import React from "react";
import { CompassHeader } from "@patternfly/react-core";

import "./SchoolHeader.css";

import SchoolLogo from "./actions/SchoolLogo";
import SchoolNavigation from "./navigation/SchoolNavigation";
import SchoolHeaderActions from "./SchoolHeaderActions";

const SchoolHeader = () => {
  
  return (
    <div className="school-header__content">
        <div className="school-header__nav">
            <SchoolNavigation />
        </div>

        <div className="school-header__actions">
            <SchoolHeaderActions />
        </div>
    </div>
    
  );
};

export default SchoolHeader;